import HeroImage from "../../components/heros/hero-image";
import imgPoles from "../../assets/images/poles.jpeg";
import PolesProduct from "./components/poles-product/poles-product";
import PolesTip from "./components/poles-tip/poles-tip";
import PolesInstallation from "./components/poles-installation/poles-installation";
import PolesAdvantages from "./components/poles-advantages/poles-advantages";
import PolesWhereToUse from "./components/poles-where-to-use/poles-where-to-use";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { MAILTO_COMMERCIAL, TEL_SEGRETERIA } from "../../constants/contacts";

const RotoinfissiPoles: React.FC = () => {
  const device = useBreakpoint();
  const isMobile = device === "mobile";
  return (
    <div className="poles">
      <HeroImage
        serviceText="SERVIZIO SPECIALIZZATO"
        serviceIcon="certificate"
        title="Pali Rotoinfissi"
        text="Tecnologia avanzata per fondazioni ad alta resistenza, con vibrazioni minime e senza asportazione di materiale."
        img={imgPoles}
        altImg="header img"
        isMobile={isMobile}
        btnLeftText="Chiamaci ora"
        btnLeftIconName="phone"
        btnRightText="Invia Email"
        btnRightIconName="envelope"
        btnLeftHref={TEL_SEGRETERIA}
        btnRightHref={MAILTO_COMMERCIAL}
      />
      <PolesProduct />
      <PolesTip />
      {/* <PolesWhatAre /> */}
      <PolesInstallation />
      <PolesAdvantages />
      <PolesWhereToUse />
    </div>
  );
};
export default RotoinfissiPoles;
